import type { CalculationResult } from "@netkeep/fee-types";
import { isNegative, money, percent } from "@/lib/format";

/**
 * The headline: net profit, large, then the three numbers sellers check most.
 * Ratios like ROI and break-even live in the full breakdown.
 */
export function ResultSummary({ result }: { result: CalculationResult | null }) {
  const currency = result?.currency ?? "USD";
  const profit = result?.netProfit ?? "0.00";
  return (
    <section className="result" aria-label="Result">
      <div>
        <p className="kicker">You keep</p>
        <p className={`hero ${isNegative(profit) ? "is-negative" : "is-profit"}`}>{money(profit, currency)}</p>
      </div>
      <div className="stats">
        <Stat label="Payout" value={money(result?.netPayout ?? "0", currency)} />
        <Stat label="Fees" value={money(result?.totalFees ?? "0", currency)} className="is-fees" />
        <Stat label="Margin" value={percent(result?.profitMarginPercent ?? null)} />
      </div>
      {result && result.taxLiability !== "0.00" ? (
        <p className="text-warning">Includes {money(result.taxLiability, currency)} sales tax you must remit.</p>
      ) : null}
    </section>
  );
}

function Stat({ label, value, className }: { label: string; value: string; className?: string }) {
  return (
    <div className="stat">
      <span className="stat__label">{label}</span>
      <span className={className ? `stat__value ${className}` : "stat__value"} title={value}>
        {value}
      </span>
    </div>
  );
}
